import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const container: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),
  /* PREPEND HERE */
};

export default container;
